/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const kbk: CommunityData = {
  code: "kbk",
  inviteCode: "kbk",
  name: "KBK",
  thumbnail: "/assets/customizations/kbk/thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/kbk`,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: "/assets/customizations/kbk/logo.png",
        styles: "w-[128px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[4px] border-[#33FF33]",
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r-[#33FF33] border-r",
      contentBg: "#001E00",
      bgDesktop: "/assets/customizations/kbk/video-bg.mp4",
      bgMobile: "/assets/customizations/kbk/video-bg-mobile.mp4",
      mainFont: "font-['HelveticaNeue']",
      primaryButton:
        "flex justify-center items-center uppercase !text-[18px] pt-1 !h-[61px] bg-[#33FF33] !text-[#000000] sm:!min-w-[186px] min-w-[160px] text-nowrap cursor-pointer font-bold",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#33FF33",
      separator: "border-t-[#33FF33] border-t",
      item: "text-[20px] text-[#33FF33] font-['HelveticaNeueCondensedBold'] h-[40px] flex sm:justify-start justify-center items-center sm:!pt-1 !pt-5",
      itemSelected: "custom-prefix",
    },
    communityLanding: {
      titles: "text-[40px] text-[#33FF33] leading-[48px] font-['HelveticaNeueCondensedBold']",
      announcements: {
        lg: {
          title:
            "text-[15px] leading-[15px] !text-[#001E00] mt-2 font-['HelveticaNeueCondensedBold']",
          subtitle:
            "font-medium text-[12px] leading-[10px] bg-[#001E00] !text-[#33FF33] h-[23px] flex items-center uppercase",
        },
        sm: {
          title:
            "text-[15px] !text-[#001E00] leading-[15px] mt-2 font-['HelveticaNeueCondensedBold']",
          subtitle:
            "font-medium !text-[#33FF33] text-[12px] leading-[10px] bg-[#001E00] !text-[#000000] h-[23px] flex items-center uppercase",
        },
      },
      event: {
        title: "text-[20px] text-[#33FF33] one-line-truncate font-['HelveticaNeueCondensedBold']",
        subtitle: "font-medium text-[#33FF33] uppercase text-[12px] leading-5",
      },
      shop: {
        title: "text-[20px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
        text: "font-medium text-[#33FF33] uppercase text-[12px] leading-5",
        customShopImage: "/assets/customizations/kbk/shop.png",
      },
      emptyOrLoadingState: "text-[#33FF33] text-[18px] font-bold",
    },
    announcements: {
      created: "font-medium text-[#33FF33] uppercase text-[12px]",
      emptyOrLoadingState: "text-[18px] text-[#33FF33] mb-[10px] font-bold",
      container: "mb-16 sm:p-11 p-7 sm:space-y-[38px] space-y-[33px]",
      header: "text-[40px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
      title: "text-[20px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
      description: "font-medium text-[#33FF33] uppercase text-[12px]",
    },
    announcement: {
      likeCount: "text-[#33FF33]",
      commentCount: "text-[#33FF33]",
      created: "font-medium text-[#33FF33] uppercase text-[12px]",
      emptyOrLoadingState: "text-[#33FF33] text-[18px] mb-[10px] font-bold",
      container: "sm:p-10 p-7 pb-8 space-y-[23px]",
      title: "text-[20px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
      description: "text-[#33FF33] font-medium uppercase text-[12px]",
      commentIconColor: "#33FF33",
      likeIconColor: "#33FF33",
    },
    events: {
      sectionHeader: "text-[20px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
      container: "mb-16 sm:p-11 p-7 sm:pb-8 sm:space-y-[57px] space-y-[25px]",
      header: "text-[40px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
      title: "text-[20px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
      emptyOrLoadingState: "text-[#33FF33]",
      duration: "mb-4 text-[#33FF33] font-medium text-[12px] uppercase",
      address: "text-[12px] uppercase text-[#33FF33]",
      separator: "mb-8 mt-2 border-b border-b-[1px] border-[#33FF33]",
    },
    event: {
      blockContainer: "flex flex-col gap-3",
      container: "flex flex-col sm:p-11 p-6",
      emptyOrLoadingState: "text-[#33FF33] text-[18px] mb-[10px] font-bold",
      header: "text-[40px] text-[#33FF33] font-['HelveticaNeueCondensedBold'] !mt-0",
      sectionTitle: "text-[20px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
      sectionSubtitle: "font-medium uppercase text-[#33FF33] text-[12px]",
      text: "font-medium uppercase text-[12px] text-[#33FF33]",
      separator: "sm:my-8 my-6 border-b border-b-[1px] border-[#33FF33]",
      map: {
        pin: "",
        border: "mb-2 border-[4px] border-[#33FF33] overflow-hidden",
        pinColor: "#33FF33",
        strokeColor: "#33FF33",
      },
    },
    eventTickets: {
      container: "flex flex-col sm:p-11 p-6",
      event: {
        title: "text-[#33FF33] text-[40px] font-['HelveticaNeueCondensedBold']",
        subtitle: "text-[#33FF33] font-medium uppercase text-[12px]",
      },
      ticket: {
        title: "text-[20px] text-[#33FF33] font-['HelveticaNeueCondensedBold']",
        description: "text-[#33FF33] font-medium uppercase text-[12px]",
        text: "text-[#33FF33] font-medium uppercase text-[12px]",
        price: "text-[#33FF33] text-[20px] font-['HelveticaNeueCondensedBold']",
        counterContainer: "bg-[#33FF33] text-[#000000] !border-[#33FF33]",
        quantity: "text-[20px] bg-[#33FF33] !border-[#33FF33] font-['HelveticaNeueCondensedBold']",
      },
      separator: "sm:my-8 my-6 border-b-[#33FF33] border-b-[1px]",
    },
    shop: {},
  },
}

export default kbk
